import { render, staticRenderFns } from "./KSRServiceForm.vue?vue&type=template&id=4cba015c&scoped=true&"
import script from "./KSRServiceForm.vue?vue&type=script&lang=js&"
export * from "./KSRServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./KSRServiceForm.vue?vue&type=style&index=0&id=4cba015c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba015c",
  null
  
)

export default component.exports